/**
 * Safely sums two values, converting them to numbers and treating non-numeric or falsy values as 0.
 *
 * @param {*} a - The first value to sum.
 * @param {*} b - The second value to sum.
 * @returns {number} The sum of a and b, with non-numeric values treated as 0.
 */
const safeSum = (a, b) => (Number(a) || 0) + (Number(b) || 0);

export default safeSum;
